import { c as _c } from "react/compiler-runtime";
import { Box, LinearProgress, Typography } from "@mui/material";
import { useAppSelector } from "#/store/hooks";

/**
 * Snackbar body that shows live Pyodide load progress from Redux state
 * (updated by the worker PROGRESS messages via pyodideSlice).
 */
export const PyodideLoadingSnackbarContent: React.FC = () => {
  const $ = _c(9);
  const progress = useAppSelector(_temp) ?? {
    value: 0,
    stage: ""
  };
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      minWidth: 220
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== progress.stage) {
    t1 = <Typography variant="body2">Loading Pyodide: {progress.stage}</Typography>;
    $[1] = progress.stage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = Math.min(100, Math.max(0, progress.value));
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      mt: 1
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <LinearProgress variant="determinate" value={t2} sx={t3} />;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t4) {
    t5 = <Box sx={t0}>{t1}{t4}</Box>;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
function _temp(state) {
  return state.pyodide.progress;
}